/** Where "Try Joble Now" sends the visitor. */
export const SIGNUP_URL = "https://app.joble.app/auth/create-account?free=true";

/** Where "Book a Demo" sends the visitor. */
export const WALKTHROUGH_URL =
  "https://joble.app.joble.app/booking/ddb49077-6fc5-4d5e-9d77-2dc485e2fd04";

export interface ProductFeature {
  icon: string;
  title: string;
  description: string;
}

export interface Product {
  id: string;
  eyebrow: string;
  name: string;
  title: string;
  description: string;
  features: ProductFeature[];
  visual: "chat" | "phone" | "workspace";
  /** Small caption shown beneath the product image. */
  caption: string;
}

export const PRODUCTS: Product[] = [
  {
    id: "web-agent",
    eyebrow: "AI Web Agent",
    name: "Sofia",
    title: "The salesperson your website never had",
    description:
      "Sofia lives on your site and talks to every visitor like your best team member would. She knows your products, prices and policies, and she never leaves a question hanging.",
    features: [
      {
        icon: "ri-flashlight-line",
        title: "Answers in seconds, 24/7",
        description: "Instant replies to product, pricing and policy questions, day or night.",
      },
      {
        icon: "ri-book-open-line",
        title: "Knows your business cold",
        description: "Reads your catalogue, services and brand voice straight from your site.",
      },
      {
        icon: "ri-user-add-line",
        title: "Turns chats into customers",
        description: "Captures leads and books appointments right inside the conversation.",
      },
    ],
    visual: "chat",
    caption: "Sofia, live on your site",
  },
  {
    id: "phone-agent",
    eyebrow: "AI Phone Agent",
    name: "Reception",
    title: "Every call answered. Every single time.",
    description:
      "Your phone agent picks up on the first ring, sounds natural, and handles the calls your team keeps missing. It also reaches out, so follow-ups and campaigns run themselves.",
    features: [
      {
        icon: "ri-phone-line",
        title: "Not one missed call",
        description: "Answers inbound calls instantly, even in a peak-hour surge.",
      },
      {
        icon: "ri-calendar-check-line",
        title: "Books and routes on the call",
        description: "Confirms appointments and sends the right details to the right person.",
      },
      {
        icon: "ri-megaphone-line",
        title: "Runs outbound for you",
        description: "Follows up leads and runs large-scale calling campaigns automatically.",
      },
    ],
    visual: "phone",
    caption: "Answering every call, live",
  },
  {
    id: "workspace",
    eyebrow: "Joble Workspace",
    name: "Workspace",
    title: "One place for every conversation and action",
    description:
      "Every chat and call lands in a single workspace. You see what was asked, what was booked, and what still needs a human. Nothing drowns in a shared inbox again.",
    features: [
      {
        icon: "ri-stack-line",
        title: "Every conversation logged",
        description: "Chats, calls and transcripts collected in one clean timeline.",
      },
      {
        icon: "ri-list-check-2",
        title: "Tasks and bookings in one view",
        description: "See appointments, follow-ups and handoffs without switching tools.",
      },
      {
        icon: "ri-line-chart-line",
        title: "See what turns into revenue",
        description: "Track which conversations became customers and which need a nudge.",
      },
    ],
    visual: "workspace",
    caption: "Your live Joble Workspace",
  },
];